import { FC, useState } from "react";
import { WalletConnectDialog } from "@/components/WalletConnect/WalletConnectDialog";

interface ConnectStepProps {
  onBack: () => void;
}

export const ConnectStep: FC<ConnectStepProps> = ({ onBack }) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      {/* Header */}
      <div className="flex flex-col gap-2 items-center text-center">
        <div className="flex items-center gap-3 self-stretch">
          <button
            onClick={onBack}
            className="p-1.5 rounded-full bg-sr-surface border border-white/[0.03] text-sr-neutral-500 hover:text-white transition-colors shrink-0 self-start mt-1"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>
          <h1 className="text-2xl sm:text-4xl font-medium text-white flex-1">
            Connect your wallet
          </h1>
        </div>
        <p className="text-sm sm:text-base text-sr-pink-muted">
          Connect a Cardano wallet to fund your Sugar Rush deposit.
        </p>
      </div>

      {/* Wallet illustration */}
      <div className="sr-card w-full p-6 flex flex-col items-center gap-4">
        <div className="w-16 h-16 rounded-full bg-sr-surface-raised flex items-center justify-center">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
            <rect x="2" y="6" width="20" height="14" rx="2" stroke="var(--color-sr-pink-light)" strokeWidth="1.5" />
            <path d="M2 10H22" stroke="var(--color-sr-pink-light)" strokeWidth="1.5" />
            <circle cx="17" cy="14.5" r="1.5" fill="var(--color-sr-lemon-muted)" />
          </svg>
        </div>
        <p className="text-sm text-sr-neutral-500 text-center">
          We support all major Cardano wallets including Eternl, Lace, Nami, and more.
        </p>
      </div>

      {/* Legal disclaimer */}
      <div className="sr-highlight-box w-full">
        <div className="flex flex-col gap-1.5">
          <p className="text-base font-medium text-sr-pink-light">
            Legal Disclaimer
          </p>
          <p className="text-xs text-sr-pink-bright">
            By connecting a wallet, you agree to our Terms and Conditions.
          </p>
        </div>
      </div>

      {/* CTA */}
      <button
        className="sr-btn-primary"
        onClick={() => setDialogOpen(true)}
      >
        Connect wallet
      </button>

      <WalletConnectDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </>
  );
};
